import React from 'react';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const TermsActions = ({ agreed, onAgreeChange, onAccept, showAcceptButton }) => {
  return (
    <div className="space-y-6">
      {showAcceptButton && (
        <div className="rounded-lg border border-border bg-card p-6">
          <Checkbox
            label="위 약관을 모두 읽었으며 이에 동의합니다"
            description="서비스 이용을 위해서는 약관 동의가 필요합니다"
            checked={agreed}
            onChange={(e) => onAgreeChange(e?.target?.checked)}
            size="lg"
            className="mb-4"
          />
          <Button
            variant="default"
            size="lg"
            fullWidth
            disabled={!agreed}
            onClick={onAccept}
            iconName="Check"
            iconPosition="left"
          >
            동의하고 계속하기
          </Button>
        </div>
      )}
    </div>
  );
};

export default TermsActions;